import React from 'react';
import { Switch } from 'antd';
import './CustomSwitch.scss';

interface CustomSwitchProps {
  onChange?: (checked: boolean) => void;
  defaultChecked?: boolean;
}

const CustomSwitch: React.FC<CustomSwitchProps> = ({ onChange, defaultChecked }) => (
  <Switch checked={defaultChecked} onChange={onChange} style={{ marginTop: '0.3rem' }} />
);

export default CustomSwitch;
